module.exports = "<input class=\"form-control\" #username \n  id=\"username\" type=\"text\" (keyup.enter)=\"checkUsername(username.value)\"\n  (blur)=\"checkUsername(username.value)\" />\n<p class=\"alert alert-success\" *ngIf=\"usernameValid\">Username is available!</p>\n<p class=\"alert alert-danger\" *ngIf=\"usernameDuplicate\">Username is not available.</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/username-checker/username-checker.component.html
// module id = ./src/app/shared/username-checker/username-checker.component.html
// module chunks = main